import React, { useState, useRef, useEffect, setTimeOut } from "react";
import axios from "axios";
import QRCode from "qrcode.react";
import { IoCopyOutline } from "react-icons/io5";
import { MdDone } from "react-icons/md";
import { IoMdClose } from "react-icons/io";
import html2canvas from "html2canvas";
import { FaLink } from "react-icons/fa6";
import { RiDownloadLine } from "react-icons/ri";
// import Lottie from "react-lottie";
// import animation from "../Revoke/animation.json";
import ImageLoading from "../../../components/ImageLoading";
import SuccessImage from "../../../images/sidebar/SuccessImage";

const CancelRevokeModal = ({
  cancelFunction,
  selectedItems,
  setReRender,
  reRender,
}) => {
  const [copyText, setCopyText] = useState(true);
  const [clickDownload, setClickDownload] = useState(false);
  const qrRef = useRef();
  const [succesState, setSuccesState] = useState(false);
  const [password, setPassword] = useState("");
  const [imageLoading, setImageLoading] = useState(false);
  // const defaultOptions = {
  //   loop: false,
  //   autoplay: true,
  //   animationData: animation,
  //   rendererSettings: {
  //     preserveAspectRatio: "xMidYMid slice",
  //   },
  // };
  const handleBulkInvoke = async () => {
    setImageLoading(true);
    // console.log(selectedItems);
    const token = localStorage.getItem("token");
    try {
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/revoke/cancel_bulk_revoke`,
        method: "POST",
        headers: { Authorization: token },
        data: {
          order_nos: selectedItems,
        },
      };
      const res = await axios(options);
      // console.log(res);
      if (res.data.message === "Revoke successfully Cancelled.") {
        setSuccesState(true);
        setTimeout(() => {
          cancelFunction(false);
        }, 3000);
        setReRender(!reRender);
        console.log(res.data.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setImageLoading(false);
    }
  };
  // useEffect(() => {
  //   console.log(password);
  // }, [password]);
  const handleCancelFunction = () => {
    console.log("cancel invoke");
    setSuccesState(true);
    setTimeout(() => {
      cancelFunction(false);
    }, 3000);
  };

  return (
    <div className="overlay z-50">
      <div
        className={`modal !w-[360px]  !justify-normal  relative !p-0 !text-left !items-center !h-[130px]`}
      >
        {!succesState && (
          <>
            {imageLoading && (
              <div className="w-full h-full flex items-center justify-center">
                <ImageLoading />
              </div>
            )}
            {!imageLoading && (
              <>
                <p className=" text-base font-semibold mt-[24px]">
                  Do you want to cancel the revoke?
                </p>

                <div className=" mt-4 flex justify-center ">
                  <button
                    className=" rounded px-4 py-[3px] border border-[#00394d] text-sm font-semibold text-[#00394d] h-[44px] mr-3"
                    onClick={() => cancelFunction(false)}
                  >
                    No
                  </button>
                  <button
                    className=" rounded px-4 py-[3px]  bg-[#00394d] text-sm font-semibold text-white h-[44px]"
                    onClick={handleBulkInvoke}
                  >
                    Yes, Cancel Revoke
                  </button>
                </div>
              </>
            )}
          </>
        )}

        {succesState && (
          <div className=" w-full h-full flex justify-center flex-col items-center">
            {/* <Lottie
              animationData={animation}
              options={defaultOptions}
              height={70}
              width={70}
            /> */}
            <SuccessImage />
            <p className=" font-bold  text-base mt-2">
              Revoke cancel, successful!
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CancelRevokeModal;
